import { NAMSHI_UAE_BASE_URL, jalaliHolidays } from "./Constants";
import dayjs from "src/utility/dayjsUtils";
// ** Checks if an object is empty (returns boolean)
export const isObjEmpty = (obj) => Object.keys(obj).length === 0;

// ** Returns K format from a number
export const kFormatter = (num) =>
  num > 999 ? `${(num / 1000).toFixed(1)}k` : num;

// ** Converts HTML to string
export const htmlToString = (html) => html.replace(/<\/?[^>]+(>|$)/g, "");

// ** Checks if the passed date is today
const isToday = (date) => {
  const today = new Date();

  return (
    /* eslint-disable operator-linebreak */
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
    /* eslint-enable */
  );
};

/**
 ** Format and return date in Humanize format
 ** Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 ** Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
export const formatDate = (
  value,
  formatting = { month: "short", day: "numeric", year: "numeric" }
) => {
  if (!value) return value;

  return new Intl.DateTimeFormat("en-US", formatting).format(new Date(value));
};

// ** Returns short month of passed date
export const formatDateToMonthShort = (value, toTimeForCurrentDay = true) => {
  const date = new Date(value);
  let formatting = { month: "short", day: "numeric" };

  if (toTimeForCurrentDay && isToday(date)) {
    formatting = { hour: "numeric", minute: "numeric" };
  }

  return new Intl.DateTimeFormat("en-US", formatting).format(new Date(value));
};

/**
 ** Return if user is logged in
 ** This is completely up to you and how you want to store the token in your frontend application
 *  ? e.g. If you are using cookies to store the application please update this function
 */
export const isUserLoggedIn = () => localStorage.getItem("userData");

export const getUserData = () => JSON.parse(localStorage.getItem("userData"));

/**
 ** This function is used for demo purpose route navigation
 ** In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 ** Please note role field is just for showing purpose it's not used by anything in frontend
 ** We are checking role just for ease
 * ? NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = (userRole) => {
  if (userRole === "admin") return "/";
  if (userRole === "client") return "/access-control";

  return "/login";
};

// ** React Select Theme Colors
export const selectThemeColors = (theme) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: "#7367f01a", // for option hover bg-color
    primary: "#7367f0", // for selected option bg-color
    neutral10: "#7367f0", // for tags bg-color
    neutral20: "#ededed", // for input border-color
    neutral30: "#ededed", // for input hover border-color
  },
});

export const currencyFormat = (nubmer) =>
  new Intl.NumberFormat().format(nubmer);

export const createTorobMetaTag = (metaArray) => {
  for (let i = 0; i < metaArray.length; i++) {
    const metaObj = metaArray[i];
    const keys = Object.keys(metaObj);
    let existingMeta = null;

    for (let j = 0; j < keys.length; j++) {
      existingMeta = document.querySelector(
        `meta[${keys[j]}='${metaObj[keys[j]]}']`
      );
      if (existingMeta) break;
    }

    if (existingMeta) {
      for (const key in metaObj) {
        if (metaObj.hasOwnProperty(key)) {
          existingMeta.setAttribute(key, metaObj[key]);
        }
      }
    } else {
      const meta = document.createElement("meta");

      for (const key in metaObj) {
        if (metaObj.hasOwnProperty(key)) {
          meta.setAttribute(key, metaObj[key]);
        }
      }

      document.head.appendChild(meta);
    }
  }
};

export const convertUrlToMozonoUrl = (code) => {
  const index = code.indexOf("/", 2); // find the index of the second '/' character after index 4
  const productCode = code.slice(0, index) + "-" + code.slice(index + 1);
  const productUrl = `/product/dp${productCode.split("?")[0]}1`;

  return productUrl;
};

export const p2e = (s) => s.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));

export const a2e = (s) => s.replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d));

export const phoneValidation = (e) => {
  e.target.value = e.target.value
    .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d))
    .replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d));

  return e;

  // return IRAN_PHONE_REGEX.test(+phone)
};

export const convertProductCodeToMZ = (code) => {
  const index = code.indexOf("/", 2);
  const productCode = code.slice(0, index) + "-" + code.slice(index + 1);
  return productCode.split("?")[0];
};

export const renderHref = (basePath, queries = {}, newQuery = {}) => {
  let urlBase = `${basePath}?`;
  queries = { ...queries, ...newQuery };
  for (const query in queries) {
    urlBase += `${query}=${queries[query]}&`;
  }
  // urlBase += `${newQuery}`

  return urlBase;
};

export function extractASIN(url) {
  const matches = url.match(/\/(dp|gp\/product|gp\/aw\/d)\/([A-Z0-9]{10})/);
  return matches && matches[2] ? matches[2] : null;
}

export function getNamshiProductSKU(url) {
  // Regular expression pattern to match SKU in the URL
  const regex1 = /\/([a-zA-Z0-9]+)\/p\//;
  const regex2 = /\/([a-zA-Z0-9]+)-\d+\/p\//;

  // Extract SKU using regular expression match
  let match = url.match(regex1);
  if (!match) {
    match = url.match(regex2);
  }

  // If match is found, return the SKU, otherwise return null
  return match ? match[1] : null;
}

export const createProductFromNamshi = (namshiProduct) => {
  let attributes = {};

  if (namshiProduct.attributes) {
    for (let key in namshiProduct.attributes) {
      attributes[key.name] = attributes[key];
    }
  }

  const product = {
    ...namshiProduct,
    flag: "node",
    code: "/dp/B06XSGG9WK?th=1&psc=1",
    url: `${NAMSHI_UAE_BASE_URL}${namshiProduct.uri}`,
    availability: true,
    title: namshiProduct.title,
    details: attributes,
    variations: namshiProduct.variants,
    abouts: [],
    images: [
      {
        hiRes:
          "https://m.media-amazon.com/images/I/71MVW4MPI2L._AC_SL1500_.jpg",
        thumb:
          "https://m.media-amazon.com/images/I/31WBpfxSaiL._AC_SR38,50_.jpg",
        large: "https://m.media-amazon.com/images/I/31WBpfxSaiL._AC_.jpg",
        main: {
          "https://m.media-amazon.com/images/I/71MVW4MPI2L._AC_SX342_.jpg": [
            342, 342,
          ],
          "https://m.media-amazon.com/images/I/71MVW4MPI2L._AC_SX385_.jpg": [
            385, 385,
          ],
          "https://m.media-amazon.com/images/I/71MVW4MPI2L._AC_SX425_.jpg": [
            425, 425,
          ],
          "https://m.media-amazon.com/images/I/71MVW4MPI2L._AC_SX466_.jpg": [
            466, 466,
          ],
          "https://m.media-amazon.com/images/I/71MVW4MPI2L._AC_SX522_.jpg": [
            522, 522,
          ],
          "https://m.media-amazon.com/images/I/71MVW4MPI2L._AC_SX569_.jpg": [
            569, 569,
          ],
          "https://m.media-amazon.com/images/I/71MVW4MPI2L._AC_SX679_.jpg": [
            679, 679,
          ],
        },
        variant: "MAIN",
        lowRes: null,
        shoppableScene: null,
      },
    ],
    store: "namshi",
  };

  return product;
};

export const generateQueryParams = (queryParams = {}) => {
  const params = new URLSearchParams();
  for (let key in queryParams) {
    params.append(key, queryParams[key]);
  }

  return params.toString();
};

export const addBusinessDays = (startDate, businessDaysToAdd) => {
  let currentDate = dayjs(startDate);
  let addedDays = 0;

  while (addedDays < businessDaysToAdd) {
    currentDate = currentDate.add(1, "day");
    const formatedDayDate = currentDate.calendar("jalali").format("YYYY/M/DD");
    const isExistOnHoliDay = jalaliHolidays.findIndex(
      (hd) => hd.date === formatedDayDate
    );
    const dayOfWeek = currentDate.day();
    // Day.js uses an index system where 0 is Sunday and 6 is Saturday
    if (dayOfWeek !== 5 && isExistOnHoliDay === -1) {
      // Exclude weekends
      addedDays++;
    }
  }

  return currentDate.toDate();
};

export function convertSearchParamsToQuery(searchParams) {
  const params = new URLSearchParams();

  for (let key in searchParams) {
    params.append(key, searchParams[key]);
  }
  return params.toString();
}
const persianNumbers = [
    /۰/g,
    /۱/g,
    /۲/g,
    /۳/g,
    /۴/g,
    /۵/g,
    /۶/g,
    /۷/g,
    /۸/g,
    /۹/g,
  ],
  arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g],
  fixNumbers = function (str) {
    if (typeof str === "string") {
      for (var i = 0; i < 10; i++) {
        str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
      }
    }
    return str;
  };

export const isPhoneValid = (phone) => {
  var regex = new RegExp("^(0|0)?9\\d{9}$");
  var result = regex.test(fixNumbers(phone));
  return result;
};

export const extractUrls = (text) => {
  // Regular expression to match URLs
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  // Find all matches
  const matches = text.match(urlRegex);
  // Return the matches or an empty array if no matches found
  return matches?.[0] || "";
};
